import React from "react";

export const TableCard = ({ handleSelectedStore, tiendas }: any) => {
  return (
    <div className="absolute bg-[rgba(255,255,255,.6)] top-[415px] left-[15px] max-w-sm rounded-[15px] overflow-x-hidden overflow-y-auto shadow-lg p-2 w-64 h-[260px] table-c-top">
      <p className="font-bold text-lg">Tiendas Activas</p>
      <div className="overflow-y-auto no-scrollbar">
        {tiendas && tiendas.length > 0 ? (
          tiendas
          .filter(
            (item: any) => item.supervisor > 0 || item.demonstrators > 0
          )
            .map((tienda: any, index: number) => (
              <div
                key={index}
                className="flex flex-col my-2 cursor-pointer"
                onClick={() =>
                  handleSelectedStore({ lat: tienda.lat, lng: tienda.lon })
                }
              >
                <p className="px-4 text-sm font-bold">{tienda.name}</p>
                <div className="flex flex-col">
                  <p className="px-4 text-sm">
                    Supervisores <strong>{tienda.supervisor}</strong>
                  </p>
                  <p className="px-4 text-sm">
                    Demostradores <strong>{tienda.demonstrators}</strong>
                  </p>
                </div>
              </div>
            ))
        ) : (
          <p className="font-[Gravity] text-bold text-sm">
            Aún no existen tiendas activas
          </p>
        )}
      </div>
    </div>
  );
};
